import { useEffect, useRef } from "react";
import { prefersReducedMotion } from "./useReducedMotion";

/** Element drifts slightly toward the pointer while hovered (primary CTAs). CSS transitions, no library. */
export function useMagnetic<T extends HTMLElement>(strength = 0.25) {
  const ref = useRef<T>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el || prefersReducedMotion() || !window.matchMedia?.("(pointer: fine)").matches) return;
    const prev = el.style.transition;
    el.style.transition = `${prev ? `${prev}, ` : ""}translate 0.4s cubic-bezier(.2,.8,.2,1)`;
    const move = (e: PointerEvent) => {
      const r = el.getBoundingClientRect();
      el.style.translate = `${(e.clientX - (r.left + r.width / 2)) * strength}px ${(e.clientY - (r.top + r.height / 2)) * strength}px`;
    };
    const leave = () => {
      el.style.translate = "0 0";
    };
    el.addEventListener("pointermove", move);
    el.addEventListener("pointerleave", leave);
    return () => {
      el.removeEventListener("pointermove", move);
      el.removeEventListener("pointerleave", leave);
      el.style.translate = "";
      el.style.transition = prev;
    };
  }, [strength]);
  return ref;
}
